export const slider_column = "slider-row w-[calc(100%+30px)] ml-[-15px] mr-[-15px]"
